import { Constants } from "appConstants";
import { IcoExternalLink } from "assets/icons";
import { Button } from "components";
import StatusTag from "components/StatusTag";
import { format, parse } from "date-fns";
import { StringHelper } from "helpers";
import FileHelper from "helpers/FileHelper";
import { Term } from "models/term/Term";
import { useNavigate } from "react-router-dom";
import "./styles.scss";

export type Section = {
	[field: string]: any;
};

type DetailsMainPanelProps = {
	data: {
		[section: string]: Section;
	};
	terms?: Term[];
	availableTerms?: boolean;
};

export default function DetailsMainPanel({
	data,
	terms,
	availableTerms
}: Readonly<DetailsMainPanelProps>) {
	const navigate = useNavigate();

	function getTermStatus(status: string | undefined) {
		return Constants.strings.pages.listing.term.statusType[
			status?.toLowerCase() as keyof typeof Constants.strings.pages.listing.term.statusType
		];
	}

	return (
		<div className="details-main-panel">
			{Object.entries(data).map(([sectionKey, sectionValue]) => (
				<div key={sectionKey} className="card">
					<div className="card-title">{sectionKey}</div>
					{Object.entries(sectionValue).map(([fieldKey, fieldData]) => (
						<div key={fieldKey} className="card-content">
							<div className="card-field">{fieldKey}</div>
							<div className="card-field-value">
								{StringHelper.isValidHttpUrl(String(fieldData)) ? (
									<Button
										kind="link"
										styled="ghost"
										size="small"
										onClick={() => window.open(fieldData, "_blank")}
										cssClass="link-button"
									>
										{fieldData}
									</Button>
								) : (
									fieldData
								)}
							</div>
						</div>
					))}
				</div>
			))}
			{terms && (
				<div className="card">
					<div className="card-title">Termos ativos</div>
					{terms?.map((term) => {
						return (
							<div key={term.id} className="card-content flex flex-col">
								<div className="card-field flex justify-between w-full pb-4">
									<div className="flex flex-row gap-4 items-center">
										<div>{term.type?.name}</div>
										<StatusTag>{getTermStatus(term.status)}</StatusTag>
									</div>
									<Button
										kind="link"
										styled="ghost"
										size="small"
										onClick={() => navigate(`terms/${term.id}`)}
										cssClass="link-button font-normal"
									>
										<div>Histórico</div>
									</Button>
								</div>
								<div>
									<div className="font-semibold text-[#707275]">Arquivo</div>
									<div className="flex flex-row gap-2 items-center">
										<Button
											kind="link"
											styled="ghost"
											size="small"
											onClick={() => window.open(term.pdfUrl, "_blank")}
											cssClass="link-button -ml-1"
										>
											{FileHelper.getFileNameFromUrl(term.pdfUrl)}
										</Button>
										<IcoExternalLink size="16" />
									</div>
								</div>
								<div className="pt-3">
									<div className="font-semibold text-[#707275]">
										Data de ativação
									</div>
									<div>
										{format(
											parse(term.startDate!, "yyyy-MM-dd", new Date()),
											"dd/MM/yyyy"
										)}
									</div>
								</div>
								<div className="pt-4">
									<Button
										styled="secondary"
										onClick={() =>
											navigate(`/backoffice/tenants/term/new/${term.id}`)
										}
										cssClass="font-semibold"
									>
										Atualizar Termo
									</Button>
								</div>
							</div>
						);
					})}
					{availableTerms && (
						<div className="flex flex-col justify-center items-center p-6 gap-4">
							{terms.length === 0 && (
								<div className="text-sm font-normal">
									Este produto ainda não possui nenhum termo ativo
								</div>
							)}

							<Button
								styled="secondary"
								onClick={() => navigate(`/backoffice/tenants/term/new`)}
							>
								Adicionar Termo
							</Button>
						</div>
					)}
				</div>
			)}
		</div>
	);
}
